"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DOMException_1 = __importDefault(require("../../exception/DOMException"));
/**
 * Class list.
 */
var ClassList = /** @class */ (function () {
    /**
     * Adds class names.
     *
     * @param ownerElement Owner element.
     */
    function ClassList(ownerElement) {
        this._ownerElement = ownerElement;
    }
    /**
     * Adds class names.
     *
     * @param classNames Class names.
     */
    ClassList.prototype.add = function () {
        var classNames = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            classNames[_i] = arguments[_i];
        }
        var attr = this._ownerElement.getAttribute('class');
        var list = attr ? attr.split(' ') : [];
        for (var _a = 0, classNames_1 = classNames; _a < classNames_1.length; _a++) {
            var className = classNames_1[_a];
            if (!list.includes(className)) {
                if (className.includes(' ')) {
                    throw new DOMException_1.default("Failed to execute 'add' on 'DOMTokenList': The token provided ('" + className + "') contains HTML space characters, which are not valid in tokens.");
                }
                list.push(className);
            }
        }
        this._ownerElement.setAttribute('class', list.join(' '));
    };
    /**
     * Adds class names.
     *
     * @param classNames Class names.
     */
    ClassList.prototype.remove = function () {
        var classNames = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            classNames[_i] = arguments[_i];
        }
        var attr = this._ownerElement.getAttribute('class');
        var list = attr ? attr.split(' ') : [];
        for (var _a = 0, classNames_2 = classNames; _a < classNames_2.length; _a++) {
            var className = classNames_2[_a];
            var index = list.indexOf(className);
            if (index !== -1) {
                list.splice(index, 1);
            }
        }
        this._ownerElement.setAttribute('class', list.join(' '));
    };
    /**
     * Check if the list contains a class.
     *
     * @param className Class name.
     * @returns TRUE if it contains.
     */
    ClassList.prototype.contains = function (className) {
        var attr = this._ownerElement.getAttribute('class');
        var list = attr ? attr.split(' ') : [];
        return list.includes(className);
    };
    /**
     * Toggle a class name.
     *
     * @param className A string representing the class name you want to toggle.
     * @param force If included, turns the toggle into a one way-only operation. If set to `false`, then class name will only be removed, but not added. If set to `true`, then class name will only be added, but not removed.
     * @returns A boolean value, `true` or `false`, indicating whether class name is in the list after the call or not.
     */
    ClassList.prototype.toggle = function (className, force) {
        var shouldAdd;
        if (force !== undefined) {
            shouldAdd = force;
        }
        else {
            shouldAdd = !this.contains(className);
        }
        if (shouldAdd) {
            this.add(className);
            return true;
        }
        this.remove(className);
        return false;
    };
    return ClassList;
}());
exports.default = ClassList;
//# sourceMappingURL=ClassList.js.map